import { useSelector, shallowEqual } from 'react-redux';
import { getMeter } from '@surfline/web-common';

export const getActiveMeter = (state) => {
  const meter = getMeter(state);
  if (meter?.treatmentState !== 'off') {
    return meter;
  }
  return null;
};

export const useMeterSelector = () => useSelector(getMeter, shallowEqual);
